import {
  QUESTION_TYPES_LOAD,
} from '../constants';

const initialState = {
  questionTypes: [
    { id: 1, name: 'Test' },
  ],
};

export default function update(state = initialState, action) {
  if (action.type === QUESTION_TYPES_LOAD) {
    return { ...state, questionTypes: action.orders };
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/questiontypes.js